import React from 'react';

import { Props } from './types';
import useChatWithSupport from './useChatWithSupport';

const Component: React.FC<Props> = ({ route = '' }) => {
  useChatWithSupport(route);

  return <></>;
};

export default Component;
export { default as useChatWithSupport } from './useChatWithSupport';
